export default "__VITE_ASSET__CR3deY8q__"